import React, { Component } from 'react';
import { Table, Row, Col, Container } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import PlayAudio from '../news/PlayAudio';

class SpecificStockNewsFull extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stockNewsList: [],
            list: [],
            pressList: [],
            symbol: this.props.symbol.toUpperCase(),
            limit: this.props.limit,
            articlesFound: true,
            pressFound: true,
        };
    }

    componentDidMount() {
        ApiService.getStockNews(150, this.state.symbol)
            .then(result1 => {
                console.log('SPecific StockNews', result1);
                this.setState({ stockNewsList: result1 });
            })
            .catch((error) => {
                console.log(error);
            });

        ApiService.getFmpArticles(2000)
            .then(result => {
                console.log('Articles', result);
                let showResult = false;
                if (result !== undefined && result.content !== undefined && result.content.length !== undefined && result.content.length > 0){
                    showResult = true;
                }
                this.setState({ list: result.content, articlesFound: showResult });
            })
            .catch((error) => {
                console.log(error);
            });

        ApiService.getPressReleases(this.state.symbol)
            .then(result => {
                console.log('Press Releases', result);
                let tmpList = [];
                let limit = 200;
                let length = result.length > limit ? limit : result.length;
                for (var i=0; i<length; i++){
                    tmpList.push(result[i]);
                } 
                let showResult = false;
                if (tmpList !== undefined && tmpList.length !== undefined && tmpList.length > 0){
                    showResult = true;
                }
                this.setState({ pressList: tmpList, pressFound: showResult}); 
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderPressRow(listValue) {
        let content = listValue.text.replace(/<a.*?>.*?<\/a>/ig, '').replace(/<p>/ig, '').replace(/<\/p>/ig, '');
        content = this.capitalizeFirstLetter(content);
        return (
            <tr key={listValue.date + Math.random()}>
                <td style={{ textAlign: 'left' }} >
                    <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{listValue.title}</div>   
                    <div style={{ fontSize: '10px' }}>{listValue.date}</div>
                    <div style={{ fontSize: '13px' }}>{content} <PlayAudio text={content}/></div>
                </td>
            </tr>
        )
    }    

    renderRow(listValue) {
        return (
            <tr key={listValue.url}>
                <td><a href={listValue.url} target="_blank" rel="noreferrer">
                    <img src={listValue.image} style={{ height: '100px', width: '100px' }} alt="" />
                </a>
                </td>
                <td style={{ textAlign: 'left' }} >
                    <a href={listValue.url} target="_blank" rel="noreferrer">{listValue.title}</a>
                    <div style={{ fontSize: '10px' }}>{listValue.publishedDate}</div>
                    <div style={{ fontSize: '15px' }}>{listValue.text} <PlayAudio text={listValue.text}/></div>
                </td>
            </tr>
        )
    }

    renderArticleRow(listValue) {
        let symbol = listValue.tickers.replace('NYSE:', '')
            .replace('NASDAQ:', '');
        let content = listValue.content.replace(/<a.*?>.*?<\/a>/ig, '').replace(/<p>/ig, '').replace(/<\/p>/ig, '');
        content = this.capitalizeFirstLetter(content);
        if (symbol !== this.state.symbol) {
            return <></>
        }

        //let url = '/chart/' + symbol;
        return (
            <tr key={listValue.url} >
                <td><img src={listValue.image} style={{ height: '100px', width: '100px' }} alt="" /></td>
                <td style={{ textAlign: 'left', fontSize: '15px' }} >
                    <div style={{ fontSize: '15px' }}>{listValue.title}</div>
                    <div style={{ fontSize: '10px' }}>{listValue.date}</div>
                    <div style={{ fontSize: '12px' }}>{content} <PlayAudio text={content}/></div>
                </td>
            </tr>
        )
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    render() {
        let tableRow;
        if (this.state.stockNewsList === undefined || this.state.stockNewsList.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td></tr>
        } else {
            tableRow = this.state.stockNewsList.map(this.renderRow.bind(this));
        }

        let articleTableRow;
        if (this.state.list === null || this.state.list.length <= 0) {
            articleTableRow = <tr><td></td><td>No Data</td></tr>
        } else {
            articleTableRow = this.state.list.map(this.renderArticleRow.bind(this));
        }

        let pressTableRow;
        if (this.state.pressList === null || this.state.pressList.length <= 0) {
            pressTableRow = <tr><td>No Data</td></tr>
        } else {
            pressTableRow = this.state.pressList.map(this.renderPressRow.bind(this));
        }        

        let newsHeader = 'News - ' + this.state.symbol;
        let articleHeader = 'Articles - ' + this.state.symbol;
        let pressHeader = 'Press Releases - ' + this.state.symbol;
        console.log('this.state.articlesFound', this.state.articlesFound, this.state.pressFound );
        return (
            <div>
            <Container fluid className="p-2">
                <Row>
                    <Col>
                        {newsHeader}
                        <Table bordered striped hover size="xs" style={{ fontSize: "15px" }}>
                            <thead>                          
                            </thead>
                            <tbody>
                                {tableRow}
                            </tbody>
                        </Table>
                    </Col>
                    
                    <Col>
                    {this.state.articlesFound ? (
                        <>
                        {articleHeader}
                        <Table bordered striped hover size="xs" responsive>
                            <thead>
                            </thead>
                            <tbody>
                                {articleTableRow}
                            </tbody>
                        </Table></>
                    ) : <></>}
                    {this.state.pressFound ? ( 
                        <>
                        {pressHeader}
                        <Table bordered striped hover size="xs" responsive>
                            <thead>
                            </thead>
                            <tbody>
                                {pressTableRow}
                            </tbody>
                        </Table></>
                    ): <></>}
                    </Col>                    
                </Row>
                </Container>
            </div>
        );
    }
}

export default SpecificStockNewsFull;
